import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_LINK } from "@/lib/translations";
import { trackEvent } from "@/lib/analytics";

export default function WhatsAppButton({ label }) {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="whatsapp-float-btn"
      onClick={() => trackEvent("whatsapp_click", { event_category: "conversion", source: "float_btn" })}
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-3 pr-5 py-3 shadow-[0_12px_30px_-8px_rgba(37,211,102,0.55)] hover:shadow-[0_18px_40px_-8px_rgba(37,211,102,0.7)] hover:-translate-y-0.5 transition-all"
    >
      <span className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
        <FaWhatsapp className="w-5 h-5" />
      </span>
      <span className="text-sm font-semibold tracking-wide max-w-0 md:max-w-[160px] overflow-hidden whitespace-nowrap transition-all">
        {label}
      </span>
    </a>
  );
}
